"use client";

import { useEffect, useState } from "react";

import { PlusIcon, SearchIcon } from "lucide-react";

import { TabsCard } from "@/components/backoffice/tabs-card";
import { ClientCreateForm } from "@/components/backoffice/cat/client/client-create-form";
import { ClientInfoLayout } from "@/components/backoffice/cat/client/client-info-layout";
import {
  ClientSearchExisting,
  ClientSearchItem,
} from "@/components/backoffice/cat/client/client-search-existing";
import { useTabHandler } from "@/hooks/use-tab-handler";

const uiText = {
  tabs: {
    create: "create",
    createLabel: "Créer Nouveau",
    search: "search",
    searchLabel: "Rechercher Existant",
  },
};

function RetailClientStep({
  onCanProceedChange,
}: {
  onCanProceedChange?: (canProceed: boolean) => void;
}) {
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);
  const [canProceedFromCreate, setCanProceedFromCreate] = useState(false);

  const tabs: React.ComponentProps<typeof TabsCard>["tabs"] = [
    {
      name: uiText.tabs.searchLabel,
      value: uiText.tabs.search,
      icon: SearchIcon,
      content: (
        <ClientSearchExisting
          selectedClientId={selectedClientId}
          onSelect={(client: ClientSearchItem) =>
            setSelectedClientId(client.id)
          }
        />
      ),
    },
    {
      name: uiText.tabs.createLabel,
      value: uiText.tabs.create,
      icon: PlusIcon,
      content: (
        <ClientCreateForm
          onCanProceedChange={setCanProceedFromCreate}
          onCreate={() => undefined}
        />
      ),
    },
  ] as const;

  const { selectedTab } = useTabHandler({
    options: tabs.map((tab) => ({ value: tab.value })),
  });

  const canProceed =
    selectedTab === uiText.tabs.search
      ? selectedClientId !== null
      : canProceedFromCreate;

  useEffect(() => {
    onCanProceedChange?.(canProceed);
  }, [canProceed, onCanProceedChange]);

  return (
    <ClientInfoLayout header={<TabsCard tabs={tabs} />}>
      {null}
    </ClientInfoLayout>
  );
}

export { RetailClientStep };
